import {connect} from 'react-redux';

import {CLIENTS_SCREEN, DASHBOARD_SCREEN} from '/enum/screen.enum';
import {userId} from '/redux/selector/currentUser.selector';
import {
  expiringCreditsCountFrontlineById,
  expiringRewardsCountAllOrgById,
} from '/redux/selector/metric.clients.selector';
import {
  allOrgClientsWithExpiringRewards,
  allOrgClientsWithExpiringWellnessCredits,
} from '/redux/selector/metric.home.selector';
import {createStructuredScreenSelector, withProps} from '/util/selector.util';

import ExpiringSection from './ExpiringSection';

const withCoachUserId = withProps({coachId: userId});

const SELECTOR_MAP = {
  expiringCreditsCountFrontline: {
    [DASHBOARD_SCREEN]: allOrgClientsWithExpiringWellnessCredits,
    [CLIENTS_SCREEN]: expiringCreditsCountFrontlineById,
  },
  expiringRewardsCountFrontlineOrg: {
    [DASHBOARD_SCREEN]: allOrgClientsWithExpiringRewards,
    [CLIENTS_SCREEN]: expiringRewardsCountAllOrgById,
  },
};

export default connect(
  createStructuredScreenSelector({
    selectorMap: SELECTOR_MAP,
    defaultScreenName: CLIENTS_SCREEN,
    effect: withCoachUserId,
  }),
)(ExpiringSection);
